import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const companyDownload = http.post(
  createMockEndpoint('/company/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
    // return HttpResponse.json(
    //   {
    //     error: {
    //       code: 'ERR-D908-0001',
    //       message: 'ダウンロード予約の可能件数を超えています。時間をおいて再度お試しください。',
    //     },
    //   },
    //   { status: 400 },
    // );
  },
);
